import { render, staticRenderFns } from "./addAdvertisingSDK.vue?vue&type=template&id=04c326be&scoped=true&"
import script from "./addAdvertisingSDK.vue?vue&type=script&lang=js&"
export * from "./addAdvertisingSDK.vue?vue&type=script&lang=js&"
import style0 from "./addAdvertisingSDK.vue?vue&type=style&index=0&id=04c326be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04c326be",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\sdk_manage_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04c326be')) {
      api.createRecord('04c326be', component.options)
    } else {
      api.reload('04c326be', component.options)
    }
    module.hot.accept("./addAdvertisingSDK.vue?vue&type=template&id=04c326be&scoped=true&", function () {
      api.rerender('04c326be', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/packagingManagement/components/addAdvertisingSDK.vue"
export default component.exports